module.exports = __webpack_public_path__ + "static/img/banner1.bebc07a2.png";